import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CombinedOverviewEffects, DepotEffects, metaReducers, reducers, ReportShiftEffects, TourEffects } from './store';
import { MomentStartDayPipe, SharedModule } from '@shared/*';
import { ActionService, ChecklistService, ShiftService, TourService, TransportService } from './services';
import { PhotosInTransitComponent } from './components/';
import { SetNameComponent } from './set-name/set-name.component';
import { OverviewComponent } from './overview.component';
import { ToursModule } from '../tours/tours.module';
import { NotificationModule } from '../components/notification/notification.module';
import { TourModule } from '../tour/tour.module';
import { LegacyShiftModule } from '../shift/legacy-shift.module';
import { BaseModule } from '../base/base.module';
import { SynchronizationStatusIconComponent } from '../components/synchronization/status-icon/synchronization-status-icon.component';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';

@NgModule({
  declarations: [OverviewComponent, SetNameComponent, PhotosInTransitComponent,],
  imports: [
    BaseModule,
    CommonModule,
    TranslateModule,
    SharedModule,
    FormsModule,
    ToursModule,
    TourModule,
    LegacyShiftModule,
    StoreModule.forFeature('overview', reducers, { metaReducers }),
    EffectsModule.forFeature([
      CombinedOverviewEffects,
      DepotEffects,
      ReportShiftEffects,
      TourEffects
    ]),
    NotificationModule,
    SynchronizationStatusIconComponent,
    ZenithComponentsModule,

  ],
  providers: [TourService, ActionService, ShiftService, ChecklistService, MomentStartDayPipe, TransportService]
})
export class OverviewModule {}
